"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledSavePrice = exports.StyledSalePriceWrapper = exports.StyledPriceContainer = exports.StyledPrevPrice = exports.StyledBasicPrice = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _fuseVariables = require("@tvg/fuse-variables");
var _fuseTypographyElement = _interopRequireDefault(require("@tvg/fuse-typography-element"));
var _fuseUtils = require("@tvg/fuse-utils");
var _config = require("./config");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var styledSalePriceWrapperConfig = _config.styledPriceConfig.styledSalePriceWrapperConfig;
var StyledPriceContainer = exports.StyledPriceContainer = _styledComponents["default"].div.attrs({
  className: 'fuse-price'
}).withConfig({
  displayName: "styled-price__StyledPriceContainer",
  componentId: "sc-mdtzko-0"
})([""]);
var getMarginByViewport = function getMarginByViewport(viewport) {
  var _styledSalePriceWrapp;
  return "\n\tmargin-bottom: ".concat((_styledSalePriceWrapp = styledSalePriceWrapperConfig.marginBottom) === null || _styledSalePriceWrapp === void 0 ? void 0 : _styledSalePriceWrapp[viewport], ";\n");
};
var setMarginBottom = function setMarginBottom(size) {
  var _buildResponsiveSize = (0, _fuseUtils.buildResponsiveSize)(size),
    _buildResponsiveSize2 = _slicedToArray(_buildResponsiveSize, 2),
    isResponsive = _buildResponsiveSize2[0],
    setViewportCss = _buildResponsiveSize2[1];
  return isResponsive ? setViewportCss(getMarginByViewport) : getMarginByViewport(size);
};
var StyledSalePriceWrapper = exports.StyledSalePriceWrapper = _styledComponents["default"].div.attrs({
  className: 'fuse-price__sale-price-wrapper'
}).withConfig({
  displayName: "styled-price__StyledSalePriceWrapper",
  componentId: "sc-mdtzko-1"
})(["", ""], function (_ref) {
  var displayFlex = _ref.displayFlex,
    size = _ref.size;
  return "\n\t\t".concat(setMarginBottom(size), "\n\t\t/* Only display as flex for viewport of tablet and above */\n\t\t@media screen and (min-width: ").concat(_fuseVariables.breakpoints.m.minWidth, ") {\n\t\t\t").concat(displayFlex ? "" : "\n\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t", "\n\t\t}\n\t");
});
var StyledBasicPrice = exports.StyledBasicPrice = (0, _styledComponents["default"])(_fuseTypographyElement["default"]).attrs({
  className: 'fuse-price__basic-price',
  color: 'var(--color-global-black)'
}).withConfig({
  displayName: "styled-price__StyledBasicPrice",
  componentId: "sc-mdtzko-2"
})(["color:", ";margin-right:var(--spacing-global-space2);"], function (_ref2) {
  var prevPrice = _ref2.prevPrice;
  return prevPrice ? "var(--color-universal-redMid)" : "var(--color-global-black)";
});
var StyledSavePrice = exports.StyledSavePrice = (0, _styledComponents["default"])(_fuseTypographyElement["default"]).attrs({
  className: 'fuse-price__save-price',
  color: 'var(--color-universal-redMid)'
}).withConfig({
  displayName: "styled-price__StyledSavePrice",
  componentId: "sc-mdtzko-3"
})(["margin-bottom:0px;"]);
var StyledPrevPrice = exports.StyledPrevPrice = (0, _styledComponents["default"])(_fuseTypographyElement["default"]).attrs({
  className: 'fuse-price__prev-price',
  color: 'var(--color-global-black)'
}).withConfig({
  displayName: "styled-price__StyledPrevPrice",
  componentId: "sc-mdtzko-4"
})(["text-decoration:line-through;margin-bottom:0;"]);